<template>
    <div class="n2-autocomplete">
        <div class="input-container active" >
            <!-- v-bind:class="{'active': !hiddenList}" -->
            <div v-if="title" v-bind:class="[titleClass]" v-on:click="clickTitle">
                {{ title }}
            </div>
            <input type="text" v-bind:value="filterText" v-on:input="onTextChanged($event)" ref="el_text"
                v-bind:class="[inputClass, errorClass]" v-on:keyup.up="move('up')" v-on:keyup.down="move('down')"
                v-on:keyup.enter="onEnter($event)" v-on:keydown.enter="$event.preventDefault()" v-on:focus="onFocus()"
                v-on:blur="onFocusout()" v-bind:disabled="disabled ? '' : null" v-bind:placeholder="placeholder"
                autocomplete="one-time-code" />
        </div>
        <div class="list-container">
            <div class="list" v-bind:class="{ 'hidden': hiddenList }">
                <div class="list-items">
                    <div v-for="(item, index) in filterdItems" class="list-item" v-bind:key="item[value_field]"
                        v-bind:class="[{ 'selected': index == selectedPosition }, item_css_class]"
                        v-on:mousedown="onItemSeleted(item, index)">
                        <div class="list-cell" v-for="field in text_field.split(',')" v-bind:key="field">
                            {{ item[field] }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="active-bg" v-if="!hiddenList"></div>

        <ul class="n2-valid" v-bind:class="{ 'n2-errors': errors }">
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'app-autocomplete',
    props: ['title', 'value', 'items', 'disabled', 'auto_stop_loading', 'text_field', 'separator', 'value_field', 'title_css_class', 'input_css_class', 'item_css_class', 'errors', 'placeholder'],
    data: function () {
        return {
            filterText: '',
            filterdItems: [],
            oldItemId: '',
            itemId: '',
            hiddenList: true,
            selectedPosition: -1,
            inputClass: this.input_css_class ? this.input_css_class : (this.title ? 'n2-autocomplete-input-alt' : 'n2-autocomplete-input'),
            titleClass: this.title_css_class ? this.title_css_class : 'n2-autocomplete-title'
        };
    },
    computed: {
        errorClass: function () {
            return this.errors ? 'n2-invalid-field' : '';
        }
    },
    watch: {
        value: function (val) {
            if (val) {
                this.itemId = val;
                if (this.items) {
                    this.items.forEach(item => {
                        if (item[this.value_field] === this.itemId) {
                            this.filterText = this.getText(item);
                        }
                    });
                }
            } else {
                this.itemId = '';
                this.filterText = '';
            }
            this.oldItemId = this.itemId;
        },
        items: function (val) {
            if (!val || val.length === 0 || !val.some(item => { return item[this.value_field] === this.itemId })) {
                this.filterText = '';
                this.itemId = '';
                this.oldItemId = this.itemId;
                this.$emit('input', this.itemId);
            }
            else {
                val.forEach(item => {
                    if (item[this.value_field] === this.itemId) {
                        this.filterText = this.getText(item);
                    }
                });
            }
        }
    },
    mounted: function () {
        if (this.items && this.items.length > 0 && this.value) {
            this.items.forEach(item => {
                if (item[this.value_field] === this.value) {
                    this.itemId = this.value;
                    this.oldItemId = this.itemId;
                    this.filterText = this.getText(item);
                }
            });
            this.filterdItems= this.items;
        }
    },
    methods: {
        getText: function (item) {
            let fields = this.text_field.split(',');
            return fields.reduce((acc, cur, index) => {
                acc = acc + item[cur];
                if (index < fields.length - 1) { acc = acc + this.separator; }
                return acc;
            }, '');
        },
        clickTitle: function () {
            this.$refs.el_text.focus();
            this.onFocus();
        },
        onFocus: function () {
            this.filterdItems = this.items;
            this.hiddenList = false;
            this.selectedPosition = -1;
        },
        onFocusout: function () {
            this.hiddenList = true;
            if (this.itemId === '') {
                this.filterText = "";
            }
        },
        onEnter: function (event) {
            if (this.selectedPosition > -1 && this.items.length > 0) {
                event.preventDefault();
                this.onItemSeleted(this.filterdItems[this.selectedPosition], this.selectedPosition);
                this.hiddenList = true;
                this.selectedPosition = -1;
            }
        },
        move: function (direction) {
            this.hiddenList = false;
            if (this.filterdItems === null) {
                this.filterdItems = this.items;
            }

            if (this.selectedPosition >= this.filterdItems.length) {
                this.selectedPosition = -1;
            }
            if (direction === 'up') {
                if (this.selectedPosition > -1) {
                    this.selectedPosition--;
                }
            }
            else if (direction === 'down') {
                if (this.selectedPosition < this.filterdItems.length - 1) {
                    this.selectedPosition++;
                }
            }
        },
        onTextChanged: function ($event) {
            this.filterText = $event.target.value;
            this.itemId = '';
            this.filter();
            this.hiddenList = false;
            if (this.oldItemId) {
                this.oldItemId = '';
                this.$emit('input', '');
                this.$emit('selected', null);
                this.filterdItems = this.items;
            }
        },
        onItemSeleted: function (item, index) {
            this.itemId = item[this.value_field];
            this.oldItemId = this.itemId;
            this.filterdItems = null;
            this.filterText = this.getText(item);
            this.$emit('input', this.itemId);
            this.$emit('selected', item);
            this.$emit('index-selected', index);

        },
        filter: function () {
            this.filterdItems = this.filterInternal(this.filterText, this.text_field.split(','), this.items);
        },

        filterInternal: function (filterText, props, originalList) {
            let filteredList;
            if (filterText && filterText.length > 0 && props && originalList) {
                filterText = filterText.toLowerCase();
                let filtered = originalList.filter(item => {
                    let match = false;
                    for (let prop of props) {
                        if (item[prop].toString().toLowerCase().indexOf(filterText) > -1) {
                            match = true;
                            break;
                        }
                    }
                    return match;
                });
                filteredList = filtered;
            } else {
                filteredList = originalList;
            }
            return filteredList;
        }
    }
}
</script>
<style lang="sass">
</style>
